import MoveTo from 'moveTo'
import enterView from 'enter-view'
import GLightbox from 'glightbox'
import imagesLoaded from 'imagesloaded'

export default {
  init() {
    const about = document.querySelectorAll('.header-menu-item a')

    // about.forEach((element) => {
    //   element.addEventListener('click', (event) => {
    //     event.preventDefault()
    //     const moveTo = new MoveTo({ tolerance: 110 })
    //     const div = document.querySelector(element.getAttribute('href'))
    //     moveTo.move(div)
    //   })
    // })

    // const nav = document.querySelector('.site-header')

    // enterView({
    //   selector: '.header-menu',
    //   enter: (el) => {
    //     el.classList.add('is-sticky')
    //   },
    //   offset: 1,
    //   exit: (el) => {
    //     el.classList.remove('is-sticky')
    //   },
    // })

    GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
    })

    const main = document.querySelector('.main-content')

    imagesLoaded(main, (instance) => {
      const goto = document.querySelector(`#${main.dataset.goto}`)
      if (goto) {
        const moveTo = new MoveTo({
          tolerance: 110,
          duration: 1200,
        })
        moveTo.move(goto)
      }
    })
  },
  finalize() {},
}
